import dataCheck from "./checkStringValidation";
const { dataTrim, deleteBlankSpace } = dataCheck;

export default class DataMigrationBaseInfo {

    _items = [];
    _itemNames = {};
    _data = [];
    _keyOfkr = [];
    _keysOfEn = [];
    _mergedItems = [];
    _failedItems = [];

    constructor(arr, keys) {
        this._data = arr;
        this._keyOfkr = keys.kr;
        this._keysOfEn = keys.en;
    }

    get items(){
        return this._items;
    }

    countName(name){
        if(this._itemNames[name]){
            this._itemNames[name] += 1;
        } else {
            this._itemNames[name] = 1;
        }
    }

    init(){
        this._itemNames = {};
        this._items = this._data.map(d => {
            const item = {};
            this.countName(deleteBlankSpace(dataTrim(d['거래처명'])));
            this._keysOfEn.map((k, idx) => {item[k] = dataTrim(d[this._keyOfkr[idx]]) || null})
            return item;
        })

        console.log('this._items : ', this._items)
    }

    dataToArray(data){
        const arr = data.map(d => {
            return Object.values(d);
        })
        arr.unshift(this._keyOfkr);

        return arr;
    }

    setCmsInfoInBaseInfo(base, cms){
        return { ...base, ...cms }
    }


    mergeData(cmsInfoNames, cmsInfoArray){
        const mergedData = [];
        const failedData = [];

        this._items.map(i => {
            const name = deleteBlankSpace(i['accountName']);
            const nameCountInCms = cmsInfoNames[name];
            const isCmsStateTrue = !!nameCountInCms && cmsInfoArray[nameCountInCms.firstIdx]?.resultYn !== 'delete'

            // cms 데이터가 없을 때 : merge 없이 진행
            if(!nameCountInCms) {
                mergedData.push(i);

            // cms 데이터가 1개 있을 때 : 데이터 merge
            } else if(!!nameCountInCms && nameCountInCms.count === 1 && isCmsStateTrue) {
                mergedData.push(this.setCmsInfoInBaseInfo(i, cmsInfoArray[nameCountInCms.firstIdx]));
                cmsInfoArray[nameCountInCms.firstIdx]['check'] = true;
                // merge 된 데이터 체크해서 cms 실패 엑셀 만들때 해당 데이터 빼고 만듦
                cmsInfoNames[name]['check'] = true;

            // cms 데이터가 1개 이상 있을 때: 실패데이터
            } else if(!!nameCountInCms && nameCountInCms.count > 1 && isCmsStateTrue){
                failedData.push({ ...i, errMsg: '중복된 CMS가 있습니다.'});

            // 효성 cms 상태 값이 신청완료 & 신청대기 외의 값을 가질 때 merge 하지 않는다.
            } else if(!isCmsStateTrue){
                failedData.push({ ...i, errMsg: '해당 거래처의 CMS의 상태가 정상적이지 않습니다.'});
            }
        })

        const onlyCMSData = cmsInfoArray.filter(d => !(d['check'] || cmsInfoNames[d['accountName']]?.count > 1));
        const duplicateCMSData = cmsInfoArray.filter(d => cmsInfoNames[d['accountName']]?.count > 1);
        const cmsOriginData = cmsInfoArray

        return { mergedData, failedData, onlyCMSData, duplicateCMSData, cmsOriginData }

    }

}